import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
    const { user, isLoading } = useContext(AuthContext);
  
    // Show a loading screen during initialization
    if (isLoading) {
      return <div>Loading...</div>;
    }
  
    // If no user is logged in, redirect to login
    if (!user) {
      return <Navigate to="/" replace />;
    }
  
    // If the user's role doesn't match the required role, redirect
    if (user.user_role !== requiredRole) {
      return <Navigate to="/" replace />;
    }
  
    // Allow access if all conditions are met
    return children;
  };
  
  export default ProtectedRoute;